import type { CarePlanCycleDetail } from "@/types/care-plan";
import type { CarePlanTemplateCycleDetail } from "@/types/care-plan-template";

export function templateCycleToDisplay(
  c: CarePlanTemplateCycleDetail,
): CarePlanCycleDetail {
  return {
    id: c.id,
    carePlanId: "",
    branchId: c.branchId,
    templateCycleId: null,
    parentCycleId: c.parentCycleId ?? null,
    name: c.name ?? null,
    passCount: c.passCount,
    gapMinutes: c.gapMinutes,
    position: c.position,
    createdDate: c.createdDate,
    updatedDate: c.updatedDate,
  };
}
